import Stack from '@common/components/stack';
import Icon from '@common/components/icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import { EConversationFilters, RouteParams } from '@modules/chat/definitions';

const ArchivedChats = (props: { basePath: string }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { filter } = useParams<RouteParams>();
  const { basePath } = props;

  const isActive = filter === EConversationFilters.ARCHIVED;

  const handleClick = () => {
    if (isActive) {
      history.push(basePath);
    } else {
      history.push(`${basePath}/filter/archived`);
    }
  };

  const classNames = [
    'tw-px-6 tw-py-3 tw-cursor-pointer tw-select-none tw-bg-gray-custom-100',
    'tw-border-b tw-border-solid tw-border-neutral-200 tw-border-x-0 tw-border-t-0',
  ].join(' ');

  const activeClassNames = [
    'tw-bg-[hsl(var(--color-primary-hue),var(--color-primary-saturation),95%)]',
    'tw-font-medium',
  ].join(' ');

  return (
    <div
      onClick={handleClick}
      className={`${classNames} ${isActive ? activeClassNames : ''}`}
    >
      <Stack
        direction="row"
        gap={2}
        align="center"
      >
        {isActive ? (
          <Icon type="chevron_left" color="grey" />
        ) : (
          <Icon type="inbox__filled" color="grey" />
        )}
        <p className={`tw-m-0 tw-flex-1 tw-select-none ${isActive ? 'tw-font-medium' : ''}`}>
          {t('chat:conversations_archived')}
        </p>
        {!isActive && (
          <Icon type="chevron_right" color="grey" />
        )}
      </Stack>
    </div>
  );
};

export default ArchivedChats;
